import { Card, CardHeader, Divider, Typography } from "@mui/material";
import { MetricsCollectionFilterButton, MetricsGrid } from "src/components";
import { useGetTeam } from "src/http";
import { useTeamMeetingSettings } from "../hooks";

interface IProps {
  teamSlug: string;
}

const TeamMetricsReview = (props: IProps) => {
  const { settings, updateMetricSettings } = useTeamMeetingSettings(props.teamSlug);
  const { data: team, isLoading: isLoadingTeam } = useGetTeam(props.teamSlug);

  if (!isLoadingTeam && team) {
    return (
      <Card>
        <CardHeader
          title={<Typography variant="h6">Metrics Review</Typography>}
          action={
            <MetricsCollectionFilterButton
              variant="icon"
              metricCollectionGuid={team.metricCollectionGuid}
              filters={settings.metrics.filters}
              onFiltersChanged={(filters) => updateMetricSettings({ filters })}
            />
          }
        />
        <Divider />

        <MetricsGrid
          metricCollectionGuid={team.metricCollectionGuid}
          filters={settings.metrics.filters}
          userCanRemove={(metric) => (team.isMember || team.isAdministrator) && metric.assignedTeam.slug !== team.slug}
        />
      </Card>
    );
  }

  return null;
};

export { TeamMetricsReview };
